import RefreshCw01 from '@untitled-ui/icons-react/build/esm/RefreshCw01';
import { Tooltip } from "antd";
import { useLazyGetVerificationResultQuery } from "api/IndividualsApiSlice";
import { BaseButton } from "./BaseButton";
import { apiPrimeSlice } from 'app-redux/store';
import { useAppDispatch } from 'app-redux/hooks';
import { useToast } from 'providers/ToastProvider';

interface RecordType {
  lastKycId?: string;
  lastKycFlowId?: string;
  status?: string;
}

interface RefreshKycStatusButtonProps {
  record: RecordType;
}

export const RefreshKycStatusButton = ({ record }: RefreshKycStatusButtonProps) => {
  const [getVerificationResult, { data, isFetching }] = useLazyGetVerificationResultQuery();
  const dispatch = useAppDispatch();
  const toast = useToast();

  if (record?.status !== 'InProgress') {
    return null;
  }

  const handlRefreshKycStatus = async () => {
    const kycFlowId = record?.lastKycFlowId ?? record?.lastKycId;
 
    if (!kycFlowId) {
      toast.warning('No verification found for this individual.');
      return;
    }
    try {
      const result = await getVerificationResult(kycFlowId).unwrap();

      if(record?.status === result){
        toast.info('Verification Status has not been changed');
      } else if(record?.status !== result){
        dispatch(apiPrimeSlice.util.invalidateTags(['IndividualsById']))
        toast.success('Verification Status has been changed');
      }
    } catch {
      toast.error('Failed to verify status update');
    }
  }

  return (
    <Tooltip title="Refresh KYC Status">
      <BaseButton
        className="secondary-button min-h-8 min-w-8"
        icon={<RefreshCw01 className="h-4 w-4" />}
        loading={isFetching}
        onClick={handlRefreshKycStatus}
      />
    </Tooltip>
  );
};